/*
 * Copyright (c) 2023. Collabro Limited
 */

import { List, ListItem, ListItemIcon } from "@mui/material";
import { BookingModel, RosterIcon } from "RosterData";
import { ReactNode } from "react";

interface BookingListProps {
  dense?: boolean;
  children: ReactNode;
}

const BookingList = (props: BookingListProps) => {
  return (
    <List
      sx={{
        maxHeight: 100,
        overflow: "auto",
        mt: 0.5,
      }}
      dense={props.dense ?? false}
    >
      {props.children}
    </List>
  );
};

export default BookingList;
